import React from 'react';
import Summary from './Summary';

interface Summary {
  time: string;
  healthcare: string;
  doctor: string;
  speciality: string;
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
  date: string;
}

interface ConsultationGroup {
  date: string;
  summaries: Summary[];
}

interface Props {
  consultationData: ConsultationGroup[];
  userId: string | null;
  username: string | null;
  conversationID: string;
  conversationType: number;
}

interface HealthRecordProps {
    userId: string | null;
    username: string | null;
    conversationID: string;
    conversationType: number;
    healthRecord: any[];
  }

const HealthRecordList: React.FC<HealthRecordProps> = ({ userId, username, conversationID, conversationType, healthRecord }) => {
  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);

    return new Intl.DateTimeFormat('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }
  
  return (
    <div className="relative p-4 border-gray-200 ">
      {healthRecord.map((group, idx) => (
        <div key={idx} className="relative space-y-8 pb-8">
          <div className="absolute -top-9 -left-4 z-10">
            <div className="inline-block bg-teal-500 text-white px-4 py-1 text-sm font-semibold">
              {formatDate(group.date)}
            </div>
          </div>
          
          {group.summaries.map((summary: any, index: any) => (
            <Summary key={index} summary={summary} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default HealthRecordList;
